import React, { useState } from 'react';

import styled from 'styled-components';

import { AICompetitiveIntelligenceType } from 'types/recommendations';

import { AICIRankingTabKey, OVERALL_VIEW_KEY } from './constants';
import MarketPosition from './MarketPosition';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  width: 100%;
  padding-top: 10px;
`;

type Props = {
  data?: AICompetitiveIntelligenceType;
};

const CompetitiveIntelligenceOverview = ({ data }: Props) => {
  const [activeTab, setActiveTab] = useState<AICIRankingTabKey>(OVERALL_VIEW_KEY);

  return (
    <Container>
      <MarketPosition data={data} activeTab={activeTab} onActiveTabChange={setActiveTab} />
    </Container>
  );
};

export default CompetitiveIntelligenceOverview;
